jQuery( document ).ready( function($) {

	// slick slider
	$( '.slide-banner' ).slick({
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 1400,
		fade: true,
		arrows: false,
		pauseOnFocus: false,
		pauseOnHover: false,
	});

	// reveal the menu
	$( '.j-show-menu' ).on( 'click', function(e) {
		e.preventDefault();

		$( this ).toggleClass( 'open' );
		$( '.navigation' ).toggleClass( 'slidein' );
		$( 'body' ).toggleClass( 'noscroll' );
		$( '.page-overlay' ).toggleClass( 'show' );
	});

	// Scroll to contact
	$( '.contact-link a' ).on( 'click', function(e) {
		e.preventDefault();

		var aid = $(this).attr( "href" );
		$( 'html,body' ).animate({
			scrollTop: $(aid).offset().top - 70
		},'slow' );

		$( '.j-show-menu' ).trigger( 'click' );
	});

	// Slider down arrow
	$( '.j-arrow' ).on( 'click', function(e) {
		e.preventDefault();

		var target = $('#main-content');
		$( 'html, body' ).stop().animate({
			scrollTop: target.offset().top - 70
		}, 800 );
	});

	// Header switch
	var header = $( '.skinny.up' );
	$(window).scroll(function() {    
		var scroll = $(window).scrollTop();

		if (scroll >= 175) {
			header.removeClass( 'up' ).addClass( 'down' );
		} else {
			header.removeClass( 'down' ).addClass( 'up' );
		}
	});

	// animate scroll
	(function($) {

		/**
		* Copyright 2012, Digital Fusion
		* Licensed under the MIT license.
		* http://teamdf.com/jquery-plugins/license/
		*
		* @author Sam Sehnert
		* @desc A small plugin that checks whether elements are within
		*     the user visible viewport of a web browser.
		*     only accounts for vertical position, not horizontal.
		*/

		$.fn.visible = function(partial) {

		  var $t            = $(this),
			  $w            = $(window),
			  viewTop       = $w.scrollTop(),
			  viewBottom    = viewTop + $w.height(),
			  _top          = $t.offset().top +50,
			  _bottom       = _top + $t.height(),
			  compareTop    = partial === true ? _bottom : _top,
			  compareBottom = partial === true ? _top : _bottom;

		return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

		};
		
	})(jQuery);

	var win = $(window);

	var allMods = $( '.animate-in' );

	allMods.each(function(i, el) {
		var el = $(el);
		if (el.visible(true)) {
			el.addClass( 'fully-visible' ); 
		} 
	});

	win.scroll(function(event) {
	  
	  allMods.each(function(i, el) {
		var el = $(el);
		if (el.visible(true)) {
			el.addClass( 'visible' ); 
		} 
	  });
	  
	});

});